<template>
  <el-select
    v-model="userId"
    size="small"
    clearable
    filterable
    remote
    :remote-method="keyword => searchUser(keyword)"
    :placeholder="placeholder || $t('trend.user')"
    @input="inputChange"
  >
    <el-option
      v-for="item in userList"
      :key="item.id"
      :label="item.account"
      :value="item.id"
      >
    </el-option>
  </el-select>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'targetUser',
  props: {
    value: [String, Number],
    placeholder: {
      type: String
    }
  },
  data () {
    return {
      userList: [],
      userId: undefined
    }
  },
  methods: {
    ...mapActions('accounts', ['searchUserListApi']),
    async searchUser (keyword) {
      if (!keyword || !keyword.trim()) {
        return
      }
      const res = await this.searchUserListApi({ keyword })
      this.userList = res
    },
    inputChange () {
      this.$emit('input', this.userId)
    }
  },
  watch: {
    value (v) {
      this.userId = v
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/targetUsers/targetUser.vue